module.exports = __webpack_public_path__ + "img/gotfertomi-coussins-cafe-5.fc211db0.jpg";